import { create } from "zustand";

const useGlobalStore = create<{
  showGDriveLoginError: boolean;
  setShowGDriveLoginError: (show: boolean) => void;
}>((set) => ({
  showGDriveLoginError: false,
  setShowGDriveLoginError: (show: boolean) =>
    set({ showGDriveLoginError: show }),
}));

export default useGlobalStore;
